import React from 'react';
import { FieldMetaProps, useField } from 'formik';
import {
  PasswordInput,
  PasswordInputProps,
} from '@adc/parallax-component-library';
import i18n from '../../../utilities/i18n';

type Props = {
  name: string;
  label: string;
  autocomplete: 'new-password' | 'current-password';
} & Partial<PasswordInputProps>;

const PasswordInputWithError = ({
  name,
  label,
  autocomplete,
  passwordRules,
  passwordRulesTitle,
  ...rest
}: Props) => {
  const [field, meta] = useField(name);

  const getPasswordValid = (fieldMeta: FieldMetaProps<any>) => {
    if (fieldMeta.touched) {
      return fieldMeta.error ? 'no' : 'yes';
    } else {
      return 'pending';
    }
  };

  let supportingTextProps;

  if (passwordRules && passwordRulesTitle) {
    supportingTextProps = {
      passwordRules,
      passwordRulesTitle,
    };
  } else {
    supportingTextProps = {
      supportingText: meta.touched && meta.error ? meta.error : '',
    };
  }

  return (
    <PasswordInput
      {...(rest as PasswordInputProps)}
      label={label}
      aria-label={label}
      valid={getPasswordValid(meta)}
      onChangeText={field.onChange(name)}
      onBlur={field.onBlur(name)}
      ariaLabelExtractor={(error: boolean) =>
        error && meta.error ? meta.error : ''
      }
      hideButtonAriaLabelExtractor={(hidden: boolean) =>
        hidden ? i18n.t('Common.showPassword') : i18n.t('Common.hidePassword')
      }
      autoComplete={autocomplete}
      {...supportingTextProps}
    />
  );
};

export default PasswordInputWithError;
